import React, { useState } from "react";

function formatCurrency(value) {
  if (!value) return "0";

  if (value >= 100000) return `₹${(value / 100000).toFixed(1)}L`;
  if (value >= 1000) return `₹${Math.round(value / 1000)}k`;

  return `₹${value}`;
}

function ExpandableCostCard({ cost }) {
  const [open, setOpen] = useState(false);

  if (!cost) return null;

  return (
    <div className="bg-white border border-gray-100 rounded-3xl p-6 shadow-sm hover:shadow-md transition">

      {/* HEADER */}
      <div
        onClick={() => setOpen(!open)}
        className="flex items-center justify-between cursor-pointer"
      >
        <div>

          <div className="text-xs uppercase tracking-widest text-gray-400">
            Budget Range
          </div>

          <div className="text-2xl font-bold text-gray-900 mt-1">
            {formatCurrency(cost.range?.min)} — {formatCurrency(cost.range?.max)}
          </div>

        </div>

        <div className="text-sm font-medium text-[#5b6f00]">
          {open ? "Hide ▲" : "Details ▼"}
        </div>
      </div>

      {/* EXPANDABLE SECTION */}
      {open && (
        <div className="mt-6 border-t border-gray-100 pt-5 space-y-3 text-sm">

          <div className="flex justify-between">
            <span className="text-gray-600"> Hotels</span>
            <span className="font-medium text-gray-900">
              {formatCurrency(cost.breakdown.hotels)}
            </span>
          </div>

          <div className="flex justify-between">
            <span className="text-gray-600"> Food</span>
            <span className="font-medium text-gray-900">
              {formatCurrency(cost.breakdown.food)}
            </span>
          </div>

          <div className="flex justify-between">
            <span className="text-gray-600"> Transport</span>
            <span className="font-medium text-gray-900">
              {formatCurrency(cost.breakdown.transport)}
            </span>
          </div>

          <div className="flex justify-between">
            <span className="text-gray-600"> Activities</span>
            <span className="font-medium text-gray-900">
              {formatCurrency(cost.breakdown.activities)}
            </span>
          </div>

          <div className="flex justify-between">
            <span className="text-gray-600"> Buffer</span>
            <span className="font-medium text-gray-900">
              {formatCurrency(cost.breakdown.buffer)}
            </span>
          </div>

          <div className="border-t border-gray-100 pt-3 mt-3 flex justify-between font-semibold text-gray-900">
            <span>Total</span>
            <span>{formatCurrency(cost.total)}</span>
          </div>

          <div className="text-xs text-gray-500 pt-2">
            Per person estimate: {formatCurrency(cost.perPerson)}
          </div>

          {/* DISCLAIMER */}
          <div className="text-xs text-gray-400 pt-3 italic">
            *This is an estimated travel cost based on average prices and may vary depending on season, availability, and personal preferences.
          </div>

        </div>
      )}
    </div>
  );
}

export default ExpandableCostCard;